import { classnames } from '@/helpers';
import { twMerge } from 'tailwind-merge';
import { TabBase } from '../types';
import PillTabBarItem from '@/components/elements/tabs/PillTabBar/PillTabBarItem';
import { useState } from 'react';

const PillTabBar = ({
  items,
  defaultSelected,
  className,
}: {
  items: TabBase[];
  defaultSelected: number;
  className?: string;
}) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(defaultSelected);

  const handleOnClick = (index: number) => {
    setSelectedTabIndex(index);
    items[index].onClick?.();
  };

  return (
    <div
      className={twMerge(
        classnames(
          'bg-bg_secondary_bold border-border_bold p-xs gap-xs flex items-end rounded-[37px] border',
          className,
        ),
      )}>
      {items.map((item: TabBase, index: number) => (
        <div key={index} className="flex flex-1 justify-between">
          <PillTabBarItem
            {...item}
            selected={index === selectedTabIndex}
            onClick={() => {
              handleOnClick(index);
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default PillTabBar;
